import React, { useState } from "react";
import "./Sidebar.css";

function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const lang = localStorage.getItem("lang") === "bn" ? "bn" : "en";

  const t = {
    en: {
      overview: "Overview",
      mockTest: "Mock Test",
      caseStudy: "Case Study",
      hazardPerception: "Hazard Perception",
      practice: "Practice",
      userAnswers: "User Answers",
      mockAnswers: "Mock Answers",
      practiceAnswers: "Practice Answers",
      hazardAnswers: "Hazard Perception Answers",
      pricing: "Subscription Pricing",
      usermocks: "Mock Question Review",
      deleteAccount: "Delete Account",
    },
    bn: {
      overview: "ওভারভিউ",
      mockTest: "মক টেস্ট",
      caseStudy: "কেস স্টাডি",
      hazardPerception: "হ্যাজার্ড পারসেপশন",
      practice: "অনুশীলন",
      userAnswers: "ব্যবহারকারীর উত্তর",
      mockAnswers: "মক টেস্ট উত্তর",
      practiceAnswers: "অনুশীলনের উত্তর",
      hazardAnswers: "হ্যাজার্ড পারসেপশন উত্তর",
      pricing: "Subscription মূল্য নির্ধারণ",
      usermocks: "মক টেস্ট",
      deleteAccount: "অ্যাকাউন্ট Delete করুন",
    },
  }[lang];

  return (
    <div
      style={{
        overflowY: "auto",
        width: "100%",
        maxWidth: "250px",
        backgroundImage: "linear-gradient(135deg, #4c3af5, #392bb8, #2c228f)",
      }}
    >
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        ☰
      </button>
      <div className="sidebar-container">
        <div
          className={`sidebar ${isOpen ? "open" : ""} ${
            lang === "bn" ? "bn-font" : ""
          }`}
        >
          <a className="sidebar-link" href="/overview">
            {t.overview}
          </a>
          <a className="sidebar-link" href="/mocktest">
            {t.mockTest}
          </a>
          <a className="sidebar-link" href="/casestudy">
            {t.caseStudy}
          </a>
          <a className="sidebar-link" href="/hazard-list">
            {t.hazardPerception}
          </a>
          <a className="sidebar-link" href="/practice">
            {t.practice}
          </a>
          <div className="sidebar-bottom">
            <a
              className="sidebar-link delete-account-link"
              href="/delete-account"
            >
              ❌ {t.deleteAccount}
            </a>
          </div>
          <div className="br"></div>
          <a className="sidebar-link" href="/pricing">
            {t.pricing}
          </a>
          <div className="dropdown">
            <div
              className="sidebar-link dropdown-toggle"
              onClick={toggleDropdown}
            >
              {t.userAnswers}
            </div>
            {isDropdownOpen && (
              <div className="dropdown-menu">
                {/* <a className="sidebar-link" href="/answers/submenu1">
                  {t.mockAnswers}
                </a>
                <a className="sidebar-link" href="/answers/submenu2">
                  {t.practiceAnswers}
                </a> */}
                <a className="sidebar-link" href="/review-hazards">
                  {t.hazardAnswers}
                </a>
                <a className="sidebar-link" href="/user-mocks">
                  {t.usermocks}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
